import { Component, inject, Input, OnInit } from "@angular/core";
import { Observable } from "rxjs";
import { PortfolioFacade } from "@modules/portfolio/domain/portfolio.facade";
import { map } from "rxjs/operators";
import { SegmentService } from "@main-services/segment.service";
import { RudderstackService } from "@main-services/rudderstack.service";

enum HideStatusEnum {
	hide = "hide",
	show = "show"
}

const hideStatus = {
	hide: { status: HideStatusEnum.hide, icon: "eye-off" },
	show: { status: HideStatusEnum.show, icon: "eye" }
};

@Component({
	selector: "hide-portfolio-value-button",
	templateUrl: "./hide-portfolio-value.component.html",
	styleUrls: ["./hide-portfolio-value.component.scss"],
	standalone: false
})
export class HidePortfolioValueComponent implements OnInit {
	@Input() public screenItHappenedOn: string;
	@Input() public colorDark: boolean = true;
	private readonly portfolioFacade = inject(PortfolioFacade);
	private readonly segmentService = inject(SegmentService);
	private readonly rudderstackService = inject(RudderstackService);
	protected readonly HideStatusEnum = HideStatusEnum;

	public isHideActive$: Observable<{ status: string; icon: string }> =
		this.portfolioFacade.isPortfolioDataHidden$.pipe(
			map((currentStatus) => (currentStatus ? hideStatus.show : hideStatus.hide))
		);
	public ngOnInit(): void {
		const storedHideActive = sessionStorage.getItem("isHideActive");
		if (storedHideActive) {
			this.portfolioFacade.hideSource.next(JSON.parse(storedHideActive));
		}
	}

	public onStatusClicked(status: HideStatusEnum): void {
		this.portfolioFacade.changeHideStatus(status === HideStatusEnum.hide);

		let trackingName = "Show portfolio values Button clicked";
		if (status === HideStatusEnum.hide) {
			trackingName = "Hide portfolio values Button clicked";
		}

		this.segmentService.track({
			name: trackingName,
			properties: {
				screen_it_happened_on: this.screenItHappenedOn
			}
		});
		this.rudderstackService.track({
			name: trackingName,
			properties: {
				screen_it_happened_on: this.screenItHappenedOn
			}
		});
	}
}
